import React from "react";
import {columnDefinition} from "./columnDefinition";

export default function TableRow({rowData, currentLanguage, currentNoteSubType}) {
    return (
        <>
            {currentNoteSubType && (
                <tr className="note-sub-type">
                    <td colSpan={columnDefinition.length}>
                        {currentNoteSubType}
                    </td>
                </tr>
            )}

            <tr>
                {columnDefinition.map(({key, render, className}, i) => (
                    <td key={key} className={className + ((i & 1) ? "" : " even") }>
                        {render
                            ? render(rowData[key], rowData, currentLanguage)
                            : rowData[key]}
                    </td>
                ))}
            </tr>
        </>
    );
}
